import React, { forwardRef, useImperativeHandle, useState, } from 'react';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import * as Styled from './SectionsAccordion.styles';
// eslint-disable-next-line react/display-name
export const SectionsAccordion = forwardRef(({ sections, initialSection, accordionStyles, containerStyles, }, ref) => {
    const [activeSection, setActiveSection] = useState(initialSection);
    const onSectionChange = (id, shouldExpand) => {
        if (shouldExpand) {
            setActiveSection(id);
        }
        else {
            setActiveSection(undefined);
        }
    };
    useImperativeHandle(ref, () => ({
        /**
         * hide all sections
         */
        hideSections() {
            setActiveSection(undefined);
        },
    }));
    return (React.createElement(Styled.AccordionContainer, { style: containerStyles }, sections.map(({ id, titleArea, dataCy, component }) => (React.createElement(Styled.Accordion, { key: id, expanded: activeSection === id, onChange: (_, expanded) => onSectionChange(id, expanded), elevation: 0 },
        React.createElement(Styled.AccordionSummary, { expandIcon: activeSection === id ? (React.createElement(ExpandLess, null)) : (React.createElement(ExpandMore, null)), "data-cy": dataCy || `accordion-${id}`, style: accordionStyles }, titleArea),
        React.createElement(Styled.AccordionDetails, null, id === activeSection && component))))));
});
